import { Workbox } from 'workbox-window'

/**
 * Initialize the Service worker workbox window that allows us
 * send and receive/listen messages/events between the main "vue" app (window)
 * and the service worker.
 * See https://developer.chrome.com/docs/workbox/modules/workbox-window#window_to_service_worker_communication
 */
export function initializeServiceWorkboxWindow(): void {
  // Service worker is not available on mobile platforms (specifically the iOS in-app browser/webview)
  // and it causes a TypeError during the workbox initialization process.
  // See:
  // - https://developer.mozilla.org/en-US/docs/Web/API/Navigator/serviceWorker#browser_compatibility
  // - https://shortform.sentry.io/issues/7060519239/?project=1443873
  if (!navigator.serviceWorker) {
    return
  }

  const wb = new Workbox(`${process.env.BASE_URL}service-worker.js`)

  wb.addEventListener('message', (event) => {
    if (event.data.type === 'CACHE_UPDATED') {
      // We probably want to customise the notification message further
      // by using the URL that was actually updated from the payload.
      // const { updatedURL } = event.data.payload
      // TODO: Uncomment this block when we are ready to launch content update notifications
      // const notificationId = appNotifications.unique({
      //   title: 'New content is available.',
      //   message: 'Please refresh the page to see it.',
      //   duration: 0,
      //   actions: [
      //     {
      //       label: 'Close',
      //       onClick: (): void => appNotifications.dismiss(notificationId),
      //     },
      //     {
      //       label: 'Refresh',
      //       onClick: (): void => window.location.reload(),
      //     },
      //   ],
      // })
    }
  })

  // Register the service worker after event listeners have been added.
  wb.register()
}
